import { styled } from "@mui/material/styles";

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: "100vh",
}));

export const ImgContainer = styled("div")(() => ({
  margin: "0px 16px 24px",
  position: "relative",
  textAlign: "center",
}));

export const Img = styled("img")(() => ({
  maxWidth: "100%",
  height: "100%",
  width: "100%",
  borderRadius: "8px",
}));

export const ImgLabel = styled("div")(() => ({
  position: "absolute",
  bottom: 0,
  left: 0,
  color: "#fff",
  margin: "16px",

  fontSize: "20px",
  fontWeight: 700,
  lineHeight: 1.2,
}));

export const Info = styled("div")(() => ({
  margin: "0 16px",
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  columnGap: "16px",
  rowGap: "16px",
}));




export const Btn = styled("div")(() => ({
  position: "sticky",
  bottom: 0,
  width: "100%",
  padding: "16px",
  display: "block",
  marginTop: "auto",
}));


export const Footer = styled("div")(() => ({
  margin: "24px 16px 0",
}));

export const Month = styled("span")(() => ({
  fontSize: "14px",
  fontWeight: "normal",
  lineHeight: "1.43",
  color: "rgba(51,51,51,0.7)",
}));

